import React, { useContext, useEffect } from 'react';
import { PostContext } from '../context/PostContext';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Badge } from '../components/ui/badge';
import { format } from 'date-fns';
import { he, enUS } from 'date-fns/locale'; // 1. מייבאים גם את הלוקאל האנגלי
import { stripHtml } from '../entities/BlogPost';

export default function CategoryPage() {
    const { t, i18n } = useTranslation();
    const [searchParams] = useSearchParams();
    const category = searchParams.get('category');
    const { posts, loading, getByCategory } = useContext(PostContext);

    // 2. מגדירים משתנה דינמי ללוקאל של התאריך
    const dateLocale = i18n.language.startsWith('he') ? he : enUS;

    useEffect(() => {
        if (category) {
            getByCategory(category, i18n.language);
        }
    }, [category, i18n.language, getByCategory]);

    const categoryName = t(`categories.${category}`);

    if (!category || categoryName === `categories.${category}`) {
        return <div className="p-12 text-center text-lg">{t('pages.category_page.not_found')}</div>;
    }

    return (
        <div className="container mx-auto px-4 py-12">
            <h1 className="text-3xl font-bold mb-8">
                {t('pages.category_page.title', { categoryName })}
            </h1>

            {loading ? (
                <div className="text-center text-gray-600 text-lg">{t('status.loading_posts')}</div>
            ) : posts.length === 0 ? (
                <div className="text-center text-gray-600 text-lg">{t('pages.category_page.no_posts')}</div>
            ) : (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    {posts.map(post => (
                        <Link
                            key={post.id}
                            to={`/post/${post.id}`}
                            className="border rounded-xl p-4 hover:shadow-lg transition"
                        >
                            <img
                                src={
                                    post.imageUrl?.trim()
                                        ? post.imageUrl
                                        : 'https://images.unsplash.com/photo-1516414447565-b14be0adf13e?auto=format&fit=crop&q=80'
                                }
                                alt={post.title}
                                className="w-full h-64 object-cover transition-transform duration-500 ease-in-out group-hover:scale-105"
                            />
                            {/* --- תיקון 1: תרגום שם הקטגוריה --- */}
                            <Badge>{t(`categories.${post.category}`)}</Badge>
                            <h2 className="text-xl font-semibold mt-2 mb-1">{post.title}</h2>
                            <p className="text-gray-600 text-sm mb-2">
                                {(() => {
                                    try {
                                        const date = new Date(post.createdAt);
                                        // --- תיקון 2: תרגום הודעת ברירת מחדל ---
                                        if (isNaN(date)) return t('post.no_date');
                                        // --- תיקון 3: שימוש בלוקאל הדינאמי ---
                                        return format(date, 'dd MMMM yyyy', { locale: dateLocale });
                                    } catch (e) {
                                        return t('post.no_date');
                                    }
                                })()}
                            </p>
                            {post.excerpt && (
                                <p className="text-gray-700 line-clamp-3">
                                    {stripHtml(post.excerpt)}
                                </p>
                            )}
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}